<template>
  <div class="modal phone_modal price_modal" v-if="price_modal">
    <div class="phone_modal__overlay bg-overlay" @click="close_modal"></div>
    <div class="phone_modal__inner price_modal__inner  bg-white" :class="{ one_col: !_.get(price_data, 'pic_layout') }">
      <div class="price_modal__close-btn pointer" @click="close_modal"
        :class="{ one_col: !_.get(price_data, 'pic_layout') }">
        <svg xmlns="http://www.w3.org/2000/svg" width="25.803" height="25.804" viewBox="0 0 25.803 25.804">
          <g id="Group_5399" data-name="Group 5399" transform="translate(-1373.377 -116.098)">
            <g id="Group_5401" data-name="Group 5401" transform="translate(1361.862 114.583)">
              <rect id="Rectangle_543" data-name="Rectangle 543" width="30.409" height="6.082" rx="3"
                transform="translate(15.815 1.515) rotate(45)" fill="#7063e9" />
              <rect id="Rectangle_1219" data-name="Rectangle 1219" width="30.409" height="6.082" rx="3"
                transform="translate(37.318 5.816) rotate(135)" fill="#7063e9" />
            </g>
          </g>
        </svg>
      </div>
      <div class="flex j_sb" v-if="!sent">
        <div class="price_modal__left-col" v-if="windowWidth >= 768 && _.get(price_data, 'pic_layout')">
          <img :src="_.get(price_data, 'image')" alt="" />
        </div>
        <div class="price_modal__right-col flex column" :class="{ one_col: !_.get(price_data, 'pic_layout') }">
          <div class="price_modal__selectors contact_page flex column">
            <el-select v-model="type_val" :placeholder="_.get(price_data, 'selector_title')" :popper-append-to-body="true"
              :disabled="_.get(price_data, 'asset_types').length === 1 ? true : false
                ">
              <el-option v-for="item in _.get(price_data, 'asset_types')" :key="_.get(item, 'id')"
                :label="_.get(item, 'title')" :value="_.get(item, 'title')">
              </el-option>
            </el-select>

            <div class="grid price_modal__row-2">
              <el-input v-model="name" :placeholder="$fn.tr('თქვენი სახელი')"></el-input>

              <el-input v-model="phone" :placeholder="$fn.tr('ტელეფონი')"></el-input>
            </div>
        
          </div>
          <div v-html="_.get(price_data[0], 'content')" class="price_modal__terms"></div>
          <div class="price_modal__send-btn button" @click.once="submit_form()" :class="{
            disabled: !type_val.length || !phone.length || !name.length
          }">
            <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 14 14">
              <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff" />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("Send")
            }}</span>
          </div>
        </div>
      </div>
      <div class="flex j_sb a_center column" v-else>
        <span class="f-24 bold uppercase" v-if="success_sent">{{
          $fn.tr("წარმატებით გაიგზავნა")
        }}</span>
        <span class="f-24 bold uppercase" v-else>{{
          $fn.tr("გაგზავნა ვერ მოხერხდა")
        }}</span>
        <div class="button" @click="
        sent = !sent;
        close_modal();
        ">
          <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
            viewBox="0 0 14 14">
            <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2"
              d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
              fill="#fff" />
          </svg>

          <span class="f-white uppercase">{{ $fn.tr("დაბრუნება") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fn from "@/helpers/func";
import resize_handler from "@/mixins/resize_handler";
export default {
  mixins: [resize_handler],
  data() {
    return {
      type_val: "",
      name: "",
      phone: "",
      success_sent: false,
      sent: false
    };
  },
  methods: {
    close_modal() {
      document.querySelector(".price_modal").classList.remove("modal_active");
      this.sent = false;
      this.success_sent = false;
      
      setTimeout(() => {
        this.$store.commit("main/setState", {
          key: "price_modal",
          val: !this.price_modal
        });
        this.$store.state.main.mails_taxonomy = false;
        this.$store.state.main.set_price_title = '';
      }, 701);
    },
 
    async submit_form() {
      console.log('click')
      let params = {
        name: this.name,
        phone: this.phone,
        asset_type: this.type_val,
        formType: "get_price_business",
        mails_taxonomy: this.$store.state.main.mails_taxonomy 
      };

      let res = await fn.postData("main/saveSubmitedForm", params);
      this.sent = true;
      if (res.status == 200) {
        this.success_sent = true;
      } else {
        this.success_sent = false;
      }
      console.log(res);
    }
  },
  computed: {
    price_modal() {
      return this.$store.state.main.price_modal;
    }, 
    price_data() {
      return _.get(this.$store, "state.main.set_price_data");
    },
    type_value() {
      return this.$store.state.main.set_price_title;
    }
  },
  watch: {
    price_modal(ns, os) {
      if (ns == true) {
        document.body.classList.add("price_modal_active");
        setTimeout(() => {
          document.querySelector(".price_modal").classList.add("modal_active");
        }, 10);
      } else {
        document.body.classList.remove("price_modal_active");
      }

      if (this.windowWidth <= 767) {
        ns == true
          ? document.querySelector("body").classList.add("modal-open")
          : document.querySelector("body").classList.remove("modal-open");
        ns == true
          ? document.querySelector("html").classList.add("modal-open")
          : document.querySelector("html").classList.remove("modal-open");
      }
    },
    // price_data: {
    //   immediate: true,
    //   deep: true,
    //   handler(ns) {
    //     if (!ns) return;

    //     if (ns.asset_types?.length === 0) return;
    //     if (ns.asset_types?.length === 1)
    //       this.type_val = ns.asset_types[0].title;
    //   }
    // },
    type_value: {
      immediate: true,
      handler(ns) {
        this.type_val = ns;
      }
    },

    sent() {
      if (this.price_data.asset_types?.length > 1) {
        this.type_val = '';

      }
      this.phone = '';
      this.name = '';
    }
  }
};
</script>
<style lang="sass" scoped>
.price_modal__terms
  &::v-deep
    a
      color: #7063e9;
    p, span, h1, h2, h3, h4, h5, h6, em, strong
      font-size: 14px
      font-family: "TBCSailec-Regular"
      line-height: 21px
</style>
<style lang="sass">
.price_modal
  &__close-btn
    position: absolute
    top: 25px
    right: 24px
    svg rect
      transition: .4s
    @media (min-width: 1024px)
      &:hover
        svg rect
          fill: #28136D
  .button
    background-color: #555D6A
    width: fit-content
    padding-left: 47px
    padding-right: 47px
    padding-top: 20px
    padding-bottom: 20px
    transition: .4s
    cursor: pointer
    margin-top: 30px
    &.disabled
      opacity: 0.5;
      pointer-events: none;
    @media (min-width: 1024px)
      &:hover
        background-color: #333333
  .el-input__inner
    background-color: #F4F6F8
    height: 60px
  .el-input.is-active .el-input__inner, .el-input__inner:focus
    border-color:#DADADA
  &__row-2
    grid-template-columns: 1fr 1fr
    grid-column-gap: 19px
    margin-top: 16px
  &__selectors
    margin-top: 28px
    margin-bottom: 30px
  &__inner
    width: 980px !important
    padding-bottom: 78px !important
    padding-top: 78px !important
    padding-right: 95px !important
    padding-left: 30px !important
    min-width: 675px !important
    border: 1px solid #707070
    &.one_col
      width: 675px !important
      padding-left: 75px !important
      min-width: initial !important
  &__right-col
    width: 59.06432748538012%
    &.one_col
      width: 100%
  &__left-col
    position: relative
    width: 32.6530612244898%
    // height: 350px
    height: auto
    margin-top: 27px
    img
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      object-fit: contain
  @media (max-width: 1679px)
    &__inner
      padding: 55px !important
      &.one_col
        padding-left: 55px !important
    &__selectors
      margin-top: 15px
      margin-bottom: 15px
    .button
      margin-top: 20px
  @media (max-width: 1365px)
    &__inner
      padding-right: 30px !important
      padding-left: 30px !important
      padding-bottom: 34px !important
      padding-top: 40px !important
      &.one_col
        padding-left: 30px !important
    .button
      padding-top: 15px
      padding-bottom: 15px
      padding-left: 30px
      padding-right: 30px
  @media (max-width: 1023px)
    &__inner
      width: 100% !important
    &__close-btn
      top: 25px
      right: initial
      left: 25px
      &.one_col
        left: initial
        right: 15px
    &__left-col
      width: 20%
    &__right-col
      width: 70%
  @media (max-width: 767px)
    &__inner
      width: 100% !important
      min-width: initial !important
      height: 100%
      &.one_col
        width: 100% !important
    &__close-btn
      top: 15px
      right: 15px
      left: initial
    &__right-col
      width: 100%
  @media (max-width: 413px)
    &__row-2
      grid-template-columns: 1fr
      grid-row-gap: 15px
    &__inner
      overflow-y:  auto
</style>
